// Sprint 10 — thin re-export so existing index.js keeps working while
// the real app composition lives under src/app/.
import App from "@/app/App";
export default App;
